var list = 'fx_2d2fb1e5_8wa721';
var listRightSlot = 'fx_2d2fb1e5_8wa722';
var listRoot = 'fx_2d2fb1e5_8wa720';

export { list, listRightSlot, listRoot };
//# sourceMappingURL=list.vanilla.mjs.map
